// @flow

import { type Pin as LegoPin } from 'app/common/react/components/PinRep/types';
import { type Pin } from 'app/packages/pinterest-flow-types/pin';

export default function isRemovablePin(pin: Pin | LegoPin): boolean {
  return Boolean(pin.promoted_is_removable);
}
